import Vue from 'vue'



import axios from 'axios'
// 延迟加载
import { Lazyload ,Toast } from 'vant';

// 腾讯地图接口使用
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)

import { Loading } from 'vant';
Vue.use(Loading);
import waterfall from "vue-waterfall2";
Vue.use(waterfall)


Vue.prototype.$toast=Toast
Vue.prototype.$axios=axios

console.log('process.env',process.env)
if(process.env.NODE_ENV=="development"){
  axios.defaults.baseURL = '/api';   //这是调用数据接口
}else {
  axios.defaults.baseURL = '/store/';   //这是调用数据接口
}


import store from './store'
import router from './login'
import App from './App.vue'

Vue.config.productionTip = false
Vue.use(Lazyload,{
  lazyComponent: true,
});
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
